import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { jsx as _jsx } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { ContactFormLinkFormatting } from "@faire/retailer-visitor-shared/components/Links";
import { isLoggedInRetailer } from "@faire/retailer-visitor-shared/lib/isLoggedInRetailer";
import { EmailPreferencesForm } from "@faire/retailer-visitor-shared/views/settings/email-preferences/components/EmailPreferencesForm";
import { useEmailPreferencesQuery } from "@faire/retailer-visitor-shared/views/settings/email-preferences/hooks/useEmailPreferencesQuery";
import { Layout } from "@faire/retailer-visitor-shared/views/settings/Layout";
import { Row } from "@faire/web--source/slate/Layout";
import { LoadingSpinner } from "@faire/web--source/slate/LoadingSpinner";
import { Typography } from "@faire/web--source/slate/Typography";
import { useQueryParams } from "@faire/web--source/ui/hooks/useQueryParams";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import emailPreferencesPath, { route as emailPreferencesRoute } from "@faire/web-api--source/routes/retailer/settings/email-preferences";
import { QueryParameters as EmailPreferencesPageQueryParams } from "@faire/web-api--source/routes/retailer/settings/email-preferences";
import qs from "query-string";
import * as React from "react";
import { Redirect, useLocation } from "react-router-dom";
export var MANAGE_EMAIL_PREFERENCES = "manageEmailPreferences";
export var OVERWRITE_COPY_KEY = "overwriteCopy";
export var EmailPreferencesPage = function() {
    var location = useLocation();
    var _useEmailPreferencesQuery = useEmailPreferencesQuery(), emailPreferencesResponse = _useEmailPreferencesQuery.emailPreferencesResponse, isQueryPreferencesLoading = _useEmailPreferencesQuery.isQueryPreferencesLoading, isQueryPreferencesError = _useEmailPreferencesQuery.isQueryPreferencesError, preferencesQueryParameters = _useEmailPreferencesQuery.preferencesQueryParameters;
    var tab = useQueryParams(EmailPreferencesPageQueryParams.parse).tab;
    var errorMessage = isQueryPreferencesError ? /*#__PURE__*/ _jsx(StrictLocalMsg, {
        id: "1u0FcY",
        defaultMessage: [
            {
                type: 0,
                value: "Something went wrong. Please try again or "
            },
            {
                type: 8,
                value: "ContactFormLinkFormatting",
                children: [
                    {
                        type: 0,
                        value: "contact us"
                    }
                ]
            },
            {
                type: 0,
                value: "."
            }
        ],
        values: {
            ContactFormLinkFormatting: ContactFormLinkFormatting
        }
    }) : undefined;
    if (!isLoggedInRetailer()) {
        // If a user is logged out pop the log in modal.
        // redirectTo is not defined if the log in modal does not exist
        if (!location.search.includes("redirectTo")) {
            var _obj;
            return /*#__PURE__*/ _jsx(Redirect, {
                to: {
                    pathname: emailPreferencesRoute,
                    search: qs.stringify((_obj = {
                        signIn: 1,
                        redirectTo: emailPreferencesPath({
                            tab: tab
                        })
                    }, _define_property(_obj, OVERWRITE_COPY_KEY, MANAGE_EMAIL_PREFERENCES), _define_property(_obj, "outgoing_email", preferencesQueryParameters.outgoing_email), _obj))
                }
            });
        } else {
            return /*#__PURE__*/ _jsx(Row, {
                justify: "center",
                align: "center",
                style: {
                    margin: "10px",
                    position: "relative"
                },
                children: /*#__PURE__*/ _jsx(LoadingSpinner, {
                    size: "small",
                    "data-test-id": "loading-spinner"
                })
            });
        }
    }
    if (isQueryPreferencesLoading) {
        return /*#__PURE__*/ _jsx(Layout, {
            page: "email_preferences",
            isLoading: true
        });
    }
    if (isQueryPreferencesError || !emailPreferencesResponse) {
        return /*#__PURE__*/ _jsx(Layout, {
            page: "email_preferences",
            children: /*#__PURE__*/ _jsx(Row, {
                justify: "center",
                align: "center",
                style: {
                    margin: "10px",
                    position: "relative"
                },
                children: /*#__PURE__*/ _jsx(Typography, {
                    color: Core.text.critical,
                    children: errorMessage
                })
            })
        });
    }
    return /*#__PURE__*/ _jsx(Layout, {
        page: "email_preferences",
        fullWidth: true,
        children: /*#__PURE__*/ _jsx(EmailPreferencesForm, {})
    });
};
